import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const HuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: radial-gradient(#00437a, #001e50);
	padding-top: var(--size-dynamic0130);
	padding-bottom: var(--size-dynamic0130);
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);

	/* Mobile */
	@media (max-width: 959px) {
		padding-left: 40px;
		padding-right: 40px;
	}
`;

export const PopupHuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: radial-gradient(#00437a, #001e50);
    padding: 46px 24px;

	/* Mobile */
	@media (max-width: 1599px) {
		padding: 24px; 20px;
	}
`;

export const PopupHuchaCardBackground2 = styled(Container)`
	border-radius: 16px;
	background: radial-gradient(#00437a, #001e50);
    padding: 46px;

	/* Mobile */
	@media (max-width: 959px) {
		padding: 24px; 20px;
	}
`;

export const PdfHuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: radial-gradient(#00437a, #001e50);
	padding: 24px;
`;

export const PdfHuchaCardBackground2 = styled(Container)`
	border-radius: 16px;
	background: radial-gradient(#00437a, #001e50);
	padding: 24px 46px;
`;
